import { useBuilderConfig } from '@ctw/shared/context/builder-config-context';

export interface GpsConfig {
  /**
   * Whether GPS (patient summarization) is enabled for the builder. When false, every GPS surface —
   * the GPS Summary tab, the overview summarization card, the `/summary` route, all upsell/limit
   * messaging, GPS network calls, and GPS telemetry — is suppressed in the App.
   */
  enabled: boolean;
  /** Whether GPS upsell/limit prompts may be shown. Independent of {@link GpsConfig.enabled}. */
  upsell: boolean;
}

/**
 * Single read point for the builder's GPS (patient summarization) settings. Both values default to
 * enabled when absent — a missing `gps` object, or a `gps` object missing either key, reads as ON —
 * so builders with no stored value are unaffected (see `getDefaultBuilderConfig`). Only an explicit
 * `false` turns a setting off. Centralizing the default here keeps every consumer consistent.
 */
export function useGpsConfig(): GpsConfig {
  const { gps } = useBuilderConfig();
  return {
    enabled: gps?.enabled ?? true,
    upsell: gps?.upsell ?? true,
  };
}
